var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subpage-wrapper"},[_c('div',{staticClass:"subpage-page__title"},[_vm._v("\n        安全设置\n    ")]),_c('div',{staticClass:"detail-box"},[_c('div',{staticClass:"detail-item"},[_c('div',{staticClass:"item-title"},[_vm._v("\n                修改绑定手机\n            ")]),_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }